import Icon from '../components/Icon.vue'

Icon.register({
  'volume-up': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M215 71.1c15-15 41-4.5 41 17v336c0 21.4-25.9 32-41 17l-89-89h-102.1c-13.3 0-24-10.8-24-24v-144c0-13.3 10.7-24 24-24h102.1zM448.4 20c79.9 52.5 127.7 140.7 127.7 236s-47.7 183.6-127.7 236c-11.6 7.6-26.5 3.8-33.5-7-7.3-11.2-4.2-26.2 7-33.5 66.3-43.5 105.8-116.6 105.8-195.6 0-79-39.6-152.1-105.8-195.6-11.2-7.3-14.3-22.3-7-33.5 7.3-11.2 22.3-14.3 33.5-7zM480 256c0 63.5-32.1 121.9-85.8 156.2-12 7.7-26.6 2.9-33.1-7.5-7.1-11.3-3.8-26.2 7.4-33.4 39.8-25.4 63.5-68.5 63.5-115.4s-23.7-90-63.5-115.4c-11.2-7.2-14.5-22.1-7.4-33.4 7.1-11.3 21.9-14.6 33.1-7.5 53.7 34.3 85.8 92.7 85.8 156.2zM338.2 179.1c28.2 15.5 45.8 45 45.8 76.9s-17.5 61.3-45.8 76.9c-11.6 6.3-26.2 2.2-32.6-9.5-6.4-11.6-2.2-26.2 9.5-32.6 12.9-7.1 20.9-20.4 20.9-34.8 0-14.4-8-27.7-20.9-34.8-11.6-6.4-15.8-21-9.5-32.6 6.4-11.6 21-15.8 32.6-9.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-up.js
// module id = 2096
// module chunks = 0